var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white px-4 lg:px-12 sticky top-0 border-b z-10"},[_c('nav',{staticClass:"text-sm max-w-7xl mx-auto"},[_c('RouterLink',{staticClass:"px-4 inline-flex h-12 items-center justify-center",class:[
        _vm.$route.name === 'accounts.projects.project.settings'
          ? 'text-blue-600 bg-gray-200'
          : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
      ],attrs:{"to":{ name: 'accounts.projects.project.settings' }}},[_vm._v(" General ")]),(_vm.$membershipHasPermissionTo('read projects'))?_c('RouterLink',{staticClass:"px-4 inline-flex h-12 items-center justify-center",class:[
        _vm.$route.name === 'accounts.projects.project.accountsParticipating'
          ? 'text-blue-600 bg-gray-200'
          : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
      ],attrs:{"to":{ name: 'accounts.projects.project.accountsParticipating' }}},[_vm._v(" Accounts Participating ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }